const i18nConfig = {
  locales: ["fr"],
  regions: {
    fr: ["fr"],
  },
  defaultLocale: "fr",
} as const

const i18nDefaultLocale = i18nConfig.defaultLocale

type TLanguage = (typeof i18nConfig)["locales"][number]

export { i18nConfig, type TLanguage, i18nDefaultLocale }
